(function() {
  let scrollListener = null;
  
  function updateGradients() {
    const cartDrawerItems = document.querySelector('cart-drawer-items.cart-drawer-items-v2');
    const drawerFooter = document.querySelector('.drawer__footer.drawer__footer-v2');
    
    if (!cartDrawerItems || !drawerFooter) return;
    
    const scrollTop = cartDrawerItems.scrollTop;
    const scrollHeight = cartDrawerItems.scrollHeight;
    const clientHeight = cartDrawerItems.clientHeight;
    
    const hasItems = cartDrawerItems.querySelector('.custom-cart-item-card');
    
    if (!hasItems) {
      cartDrawerItems.classList.remove('has-scrolled');
      drawerFooter.classList.remove('at-bottom');
      return;
    }
    

    if (scrollTop > 5) {
      cartDrawerItems.classList.add('has-scrolled');
    } else {
      cartDrawerItems.classList.remove('has-scrolled');
    }
    

    const isAtBottom = scrollHeight - scrollTop - clientHeight < 5;
    if (isAtBottom) {
      drawerFooter.classList.add('at-bottom');
    } else {
      drawerFooter.classList.remove('at-bottom');
    }
  }

  function attachScrollListener() {
    const cartDrawerItems = document.querySelector('cart-drawer-items.cart-drawer-items-v2');
    if (!cartDrawerItems) return false;
    
    if (scrollListener) {
      cartDrawerItems.removeEventListener('scroll', scrollListener);
    }
    
    scrollListener = updateGradients;
    cartDrawerItems.addEventListener('scroll', scrollListener, { passive: true });
    
    updateGradients();
    return true;
  }

  let gradientObserveTimer = null;
  function watchForGradientChanges() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) {
      setTimeout(watchForGradientChanges, 100);
      return;
    }

    const observer = new MutationObserver(function () {
      if (gradientObserveTimer) clearTimeout(gradientObserveTimer);
      gradientObserveTimer = setTimeout(function () {
        gradientObserveTimer = null;
        attachScrollListener();
      }, 250);
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }


  function initGradientHandler() {
    setTimeout(() => {
      attachScrollListener();
      watchForGradientChanges();
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGradientHandler);
  } else {
    initGradientHandler();
  }

  window.updateCartGradients = updateGradients;
  window.destroyCartGradients = function() {
    const cartDrawerItems = document.querySelector('cart-drawer-items.cart-drawer-items-v2');
    if (cartDrawerItems && scrollListener) {
      cartDrawerItems.removeEventListener('scroll', scrollListener);
    }
    scrollListener = null;
  };
})();




(function() {
  let dragListener = null;
  let mouseMoveListener = null;
  let mouseUpListener = null;
  /** Grid element listeners are currently attached to — avoid rebinding when observer fires on unrelated cart churn. */
  let dragListenersBoundGrid = null;
  let dragObserveTimer = null;

  let activeDragState = {
    isDragging: false,
    startX: 0,
    scrollLeft: 0,
    startTouchX: 0,
    startTouchScrollLeft: 0
  };

  function refreshUpsellItemStyles(upsellGrid) {
    const items = upsellGrid.querySelectorAll('.cart-upsell__item.cart-upsell__item-v2');
    items.forEach(function (item) {
      item.style.flexShrink = '0';
      item.style.userSelect = 'none';
    });
  }

  function updateDragListeners() {
    const upsellGrid = document.querySelector('.cart-upsell__grid.cart-upsell__grid-v2');

    if (!upsellGrid) {
      if (dragListenersBoundGrid && dragListener) {
        dragListenersBoundGrid.removeEventListener('mousedown', dragListener);
        dragListenersBoundGrid.removeEventListener('mouseleave', dragListener);
        dragListenersBoundGrid.removeEventListener('touchstart', dragListener);
      }
      if (mouseMoveListener) {
        document.removeEventListener('mousemove', mouseMoveListener);
        document.removeEventListener('touchmove', mouseMoveListener);
      }
      if (mouseUpListener) {
        document.removeEventListener('mouseup', mouseUpListener);
        document.removeEventListener('touchend', mouseUpListener);
      }
      dragListener = null;
      mouseMoveListener = null;
      mouseUpListener = null;
      dragListenersBoundGrid = null;
      return false;
    }

    /** Same DOM node — cart drawer still mutating for other reasons (Shopify/pub-sub). Refresh item styles only. */
    if (dragListenersBoundGrid === upsellGrid && dragListener) {
      refreshUpsellItemStyles(upsellGrid);
      return true;
    }

    if (dragListener && dragListenersBoundGrid) {
      dragListenersBoundGrid.removeEventListener('mousedown', dragListener);
      dragListenersBoundGrid.removeEventListener('mouseleave', dragListener);
      dragListenersBoundGrid.removeEventListener('touchstart', dragListener);
    }
    
    if (mouseMoveListener) {
      document.removeEventListener('mousemove', mouseMoveListener);
      document.removeEventListener('touchmove', mouseMoveListener);
    }

    if (mouseUpListener) {
      document.removeEventListener('mouseup', mouseUpListener);
      document.removeEventListener('touchend', mouseUpListener);
    }
    
    dragListener = function(e) {
      if (e.type === 'mousedown') {
        activeDragState.isDragging = true;
        activeDragState.startX = e.pageX - upsellGrid.offsetLeft;
        activeDragState.scrollLeft = upsellGrid.scrollLeft;
        upsellGrid.style.cursor = 'grabbing';
        upsellGrid.style.userSelect = 'none';
        e.preventDefault();
      } else if (e.type === 'mouseleave') {
        if (activeDragState.isDragging) {
          activeDragState.isDragging = false;
          upsellGrid.style.cursor = 'grab';
          upsellGrid.style.userSelect = 'auto';
        }
      } else if (e.type === 'touchstart') {
        if (e.touches.length > 0) {
          activeDragState.isDragging = true;
          activeDragState.startTouchX = e.touches[0].pageX - upsellGrid.offsetLeft;
          activeDragState.startTouchScrollLeft = upsellGrid.scrollLeft;
        }
      }
    };
    
    mouseMoveListener = function(e) {
      if (!activeDragState.isDragging) return;
      
      if (e.type === 'mousemove') {
        e.preventDefault();
        const x = e.pageX - upsellGrid.offsetLeft;
        const walk = (x - activeDragState.startX) * 2;
        upsellGrid.scrollLeft = activeDragState.scrollLeft - walk;
      } else if (e.type === 'touchmove') {
        if (!e.touches.length) return;
        const x = e.touches[0].pageX - upsellGrid.offsetLeft;
        const walk = (x - activeDragState.startTouchX) * 2;
        upsellGrid.scrollLeft = activeDragState.startTouchScrollLeft - walk;
      }
    };
    
    mouseUpListener = function(e) {
      if (e.type === 'mouseup' || e.type === 'touchend') {
        if (activeDragState.isDragging) {
          activeDragState.isDragging = false;
          upsellGrid.style.cursor = 'grab';
          upsellGrid.style.userSelect = 'auto';
        }
      }
    };
    
    upsellGrid.addEventListener('mousedown', dragListener, false);
    upsellGrid.addEventListener('mouseleave', dragListener, false);
    upsellGrid.addEventListener('touchstart', dragListener, { passive: false });
    
    document.addEventListener('mousemove', mouseMoveListener, false);
    document.addEventListener('mouseup', mouseUpListener, false);
    document.addEventListener('touchmove', mouseMoveListener, { passive: false });
    document.addEventListener('touchend', mouseUpListener, false);
    
    upsellGrid.style.cursor = 'grab';

    refreshUpsellItemStyles(upsellGrid);

    dragListenersBoundGrid = upsellGrid;

    return true;
  }

  function scheduleDragListenersFromObserver() {
    if (dragObserveTimer) clearTimeout(dragObserveTimer);
    dragObserveTimer = setTimeout(function () {
      dragObserveTimer = null;
      updateDragListeners();
    }, 250);
  }

  function watchForDragChanges() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) {
      setTimeout(watchForDragChanges, 100);
      return;
    }

    const observer = new MutationObserver(function () {
      scheduleDragListenersFromObserver();
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }


  function initDragHandler() {
    setTimeout(function() {
      updateDragListeners();
      watchForDragChanges();
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDragHandler);
  } else {
    initDragHandler();
  }

  window.updateUpsellDragListeners = updateDragListeners;
  window.destroyUpsellDrag = function() {
    var gridEl = dragListenersBoundGrid || document.querySelector('.cart-upsell__grid.cart-upsell__grid-v2');
    if (gridEl && dragListener) {
      gridEl.removeEventListener('mousedown', dragListener);
      gridEl.removeEventListener('mouseleave', dragListener);
      gridEl.removeEventListener('touchstart', dragListener);
    }
    if (mouseMoveListener) {
      document.removeEventListener('mousemove', mouseMoveListener);
      document.removeEventListener('touchmove', mouseMoveListener);
    }
    if (mouseUpListener) {
      document.removeEventListener('mouseup', mouseUpListener);
      document.removeEventListener('touchend', mouseUpListener);
    }
    dragListener = null;
    mouseMoveListener = null;
    mouseUpListener = null;
    dragListenersBoundGrid = null;
  };
})();




window.addDrawerUpsellToCart = function(button) {
  const variantId = button.dataset.productId;
  const upsellItem = button.closest('.cart-upsell__item');
  
  button.disabled = true;
  button.textContent = 'ADDING...';
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: 1
      }]
    })
  })
  .then(response => response.json())
  .then(data => {
    button.textContent = 'ADDED';
    
    if (upsellItem) {
      upsellItem.style.transition = 'opacity 0.3s ease';
      upsellItem.style.opacity = '0';
      
      setTimeout(() => {
        upsellItem.style.display = 'none';
        
        const visibleItems = Array.from(document.querySelectorAll('.cart-upsell__item')).filter(
          item => item.style.display !== 'none'
        );
        if (visibleItems.length === 0) {
          const upsellSection = document.getElementById('cart-upsells-section');
          if (upsellSection) {
            upsellSection.style.transition = 'opacity 0.3s ease';
            upsellSection.style.opacity = '0';
            setTimeout(() => {
              upsellSection.style.display = 'none';
            }, 300);
          }
        }
      }, 300);
    }
    
    fetch(window.location.href)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        const newCartItems = doc.querySelector('#CartDrawer-CartItems');
        const currentCartItems = document.querySelector('#CartDrawer-CartItems');
        if (newCartItems && currentCartItems) {
          currentCartItems.innerHTML = newCartItems.innerHTML;
        }
        
        const newFooter = doc.querySelector('.cart-footer__subtotal');
        const currentFooter = document.querySelector('.cart-footer__subtotal');
        if (newFooter && currentFooter) {
          currentFooter.innerHTML = newFooter.innerHTML;
        }
        
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer', cartData: data });
        }
        
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      })
      .catch(error => {
        console.error('Error updating cart drawer:', error);
      });
    
    setTimeout(() => {
      button.textContent = 'ADD TO CART';
      button.disabled = false;
    }, 1000);
  })
  .catch(error => {
    console.error('Error:', error);
    button.textContent = 'ERROR';
    setTimeout(() => {
      button.textContent = 'ADD TO CART';
      button.disabled = false;
    }, 2000);
  });
};




function isIE() {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');
  const trident = ua.indexOf('Trident/');
  return msie > 0 || trident > 0;
}

if (isIE()) {
  const cartSubmitInput = document.createElement('input');
  cartSubmitInput.setAttribute('name', 'checkout');
  cartSubmitInput.setAttribute('type', 'hidden');
  const cartForm = document.querySelector('#CartDrawer-Form');
  if (cartForm) {
    cartForm.appendChild(cartSubmitInput);
  }
  
  const checkoutBtn = document.querySelector('#CartDrawer-Checkout');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function (event) {
      event.preventDefault();
      if (cartForm) {
        cartForm.submit();
      }
    });
  }
}



window.checkCartDrawerScroll = function() {
  const cartDrawerItems = document.querySelector('cart-drawer-items.cart-drawer-items-v2');
  if (cartDrawerItems) {
    const scrollHeight = cartDrawerItems.scrollHeight;
    const scrollTop = cartDrawerItems.scrollTop;
    const clientHeight = cartDrawerItems.clientHeight;
    console.log(`Scroll: ${scrollTop}/${scrollHeight - clientHeight}`);
  }
  
  const grid = document.querySelector('.cart-upsell__grid.cart-upsell__grid-v2');
  if (grid) {
    console.log(`Grid scroll: ${grid.scrollLeft}/${grid.scrollWidth - grid.clientWidth}`);
  }
};